import React, { useEffect } from "react";
import { useState } from "react";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import "../../Style/LandingPage.css";
import { Avatar } from "@mui/material";
import Data_Table from "./Data_Table";
import LeadDetails from "./LeadDetails";
import defaultAvatar from "../../Images/default-avatar.svg";
import bb3 from "../../Images/bb3.jpg";
import { FaPaintBrush } from "react-icons/fa";
import { AiOutlineFileWord } from "react-icons/ai";
import { AiOutlineFilePdf } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { BiImage } from "react-icons/bi";
import {
  FaFileInvoiceDollar,
  FaFileAlt,
  FaUserAlt,
  FaTasks,
  FaHeadset,
  FaEnvelope,
  FaShoppingCart,
  FaReceipt,
  FaFileInvoice,
  FaPlus,
  FaCartPlus,
} from "react-icons/fa";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { path_url } from "../../Config/config";
import VendorProfileCard from "../components/VendorProfileCard";
import {
  faCirclePlus,
  faPlusSquare,
  faSquarePlus,
  faPenToSquare,
  faFileInvoice,
  faTasks,
  faReceipt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OutsideClickHandler from "react-outside-click-handler";
import QuickEmailModal from "../components/QuickEmailModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function LeadDetailsParent() {
  const [showComponent, setShowComponent] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [profile, setProfile] = useState([]);
  const [Details, setDetails] = useState([]);
  const [showMobileButtons, setShowMobileButtons] = useState(true);
  const [visibile, setVisible] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);

  // Dummy data for the Open Items List (used when API returns no records)
  const dummyOpenItems = [
    {
      subject: "Follow-up Call",
      status: "OPEN",
      duedate: "2026-07-20",
      priority: "High",
      source: "Website",
      assigned: "Rahul Sharma",
      createdBy: "Admin",
    },
    {
      subject: "Send Proposal",
      status: "IN PROGRESS",
      duedate: "2026-07-22",
      priority: "Medium",
      source: "Referral",
      assigned: "Priya Verma",
      createdBy: "Admin",
    },
    {
      subject: "Product Demo",
      status: "OPEN",
      duedate: "2026-07-25",
      priority: "High",
      source: "Social Media",
      assigned: "Amit Singh",
      createdBy: "Manager",
    },
    {
      subject: "Contract Review",
      status: "PENDING",
      duedate: "2026-07-28",
      priority: "Critical",
      source: "Campaign",
      assigned: "Neha Joshi",
      createdBy: "Admin",
    },
    {
      subject: "Requirement Gathering",
      status: "OPEN",
      duedate: "2026-07-30",
      priority: "Normal",
      source: "Walk-in",
      assigned: "Saniya Gupta",
      createdBy: "Manager",
    },
  ];


  const handleDrop = () => {
    setVisible(!visibile);
  };
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Type, setType] = useState(true);

  const handleID = () => {
    setId(!Id);
    setVisible(true);
  };
  const handleSubject = () => {
    setSubject(!Subject);
    setVisible(true);
  };
  const handleStatus = () => {
    setStatus(!Status);
    setVisible(true);
  };
  const handlePriority = () => {
    setPriority(!Priority);
    setVisible(true);
  };
  const handleAssigned = () => {
    setAssigned(!Assigned);
    setVisible(true);
  };
  const handleType = () => {
    setType(!Type);
    setVisible(true);
  };
  const handleDuedate = () => {
    setDuedate(!Duedate);
    setVisible(true);
  };
  const handleToggle = () => {
    setShowComponent(!showComponent);
  };
  const { id } = useParams();

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  useEffect(() => {
    fetchdetails();
    return () => {
      window.__CRM_PAGE_CONTEXT__ = null;
      window.dispatchEvent(new CustomEvent("crm-context-updated"));
    };
  }, []);
  async function fetchdetails() {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(`${path_url}/lead/details/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setDetails(response.data.body);
      setProfile(response.data.body.lead || response.data.body);
    } catch (error) {}
  }
  const handleMobileButtonClick = () => {
    setShowMobileButtons(!showMobileButtons);
  };
  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div>
            <div
              className="col-12 w-9 d-flex justify-content-center"
              style={{ paddingTop: 5, position: "relative" }}
            >
              <img
                src={bb3}
                alt=""
                style={{
                  width: "100%",
                  height: "5rem",
                  objectFit: "cover",
                  backgroundPosition: "center",
                }}
              />
              <Avatar
                src={defaultAvatar}
                className="my-5"
                style={{
                  position: "absolute",
                  left: "51%",
                  transform: "translateX(-50%)",
                  zIndex: 3,
                  width: "6rem",
                  height: "6rem",
                  border: "3px solid #ffffff",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#e2e8f0",
                }}
              />
            </div>
            <div className="col-12 justify-content-center">
              <div
                className="row justify-content-center"
                style={{ marginTop: "3.3rem" }}
              >
                <div className="content-header">
                  <div className="content-fluid">
                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <h4>Lead Details</h4>
                      </div>
                      <div className="col-sm-6">
                        <ul className="breadcrumb float-sm-right mb-4">
                          <li className="breadcrumb-item">
                            <a href="#">Home</a>
                          </li>
                          <li className="breadcrumb-item">General Form</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* </div> */}

                <div className="col-12 bg-white">
                  <div className="row customer-detail">
                    <div className="col-md-4 mt-2">
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "0.5rem",
                        }}
                      >
                        {document.documentElement.clientWidth <= 768 ? (
                          <button
                            className="btn btn-md bg-gradient-primary"
                            style={{
                              background:
                                "#007bff linear-gradient(180deg,#268fff,#007bff) repeat-x",
                              color: "#fff",
                              display: "flex",
                              gap: "0.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "1.2rem",
                              margin: "0 auto",
                            }}
                            onClick={handleMobileButtonClick}
                          >
                            {showMobileButtons ? "Hide" : "Show"} Buttons
                          </button>
                        ) : null}
                        {showMobileButtons ? (
                          <>
                            <div
                              className="pbuttons"
                              style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}
                            >
                              {/* Email Button removed */}
                              <div
                                className="rightside dropdown"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "0.5rem",
                                }}
                              >
                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Invoice
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Purchase
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={handleDuedate}
                                    >
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Proforma
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div
                                      className="dropdown-item"
                                      onClick={handleID}
                                    >
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={handleDuedate}
                                    >
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Quotation
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Contact
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div
                                      className="dropdown-item"
                                      onClick={handleID}
                                    >
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={handleDuedate}
                                    >
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Create Task
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Service
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div
                                      className="dropdown-item"
                                      onClick={handleID}
                                    >
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={handleDuedate}
                                    >
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setVisible(false);
                                  }}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                                    Send Mail
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      visibile ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {/* Add your dropdown content here */}
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Invoice
                                    </div>
                                    <div className="dropdown-item">
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div className="dropdown-item">
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>
                              </div>
                            </div>
                          </>
                        ) : (
                          <> </>
                        )}
                      </div>
                      <div className="vendor-profile mt-2">
                        <VendorProfileCard Details={profile} onSendMail={() => setShowEmailModal(true)} />
                      </div>
                    </div>

                    <div className="col-md-8 mt-5">
                      <div className="row" style={{ marginTop: "30px" }}>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Invoice
                              </span>
                              <span className="info-box-text text-center text-muted mb-0">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalInvoice}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Service Request
                              </span>
                              <span className="info-box-text text-center text-muted mb-0">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalServiceRequets}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Order
                              </span>
                              <span className="info-box-text text-center text-muted mb-0 ">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalOrders}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Details?.dueToday?.length ? (
                        <Data_Table
                          tableData={Details?.dueToday}
                          title={"Due Today data"}
                        />
                      ) : (
                        ""
                      )}
                      <Data_Table
                        tableData={Details?.openItemsList?.length ? Details.openItemsList : dummyOpenItems}
                        title={"Open Items List"}
                      />

                      {/* {Details?.dueToday?.length > 0 && (
      <DataTable tableData={Details?.dueToday} title="Due Today Data" />
    )}
    <DataTable tableData={Details?.openItemsList} title="Open Items List" /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LeadDetails Details={Details} refetchDetails={fetchdetails} />
          <UserFooter />
        </div>
      </div>

      <QuickEmailModal
        isOpen={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        contact={profile}
        contactType="Lead"
      />
    </>
  );
}